<template>
  <div class="zy-health rescue-processing-page">
    <!-- 顶部导航栏 -->
    <header class="processing-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-title">启动救援中</div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="processing-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 内容卡片 -->
      <div class="processing-content-card">
      <!-- 图标 -->
      <div class="processing-icon">
        <img src="@/assets/personalInformation/rescueProcessing.png" alt="救援处理中" class="processing-icon-img" />
      </div>

      <!-- 主标题 -->
      <div class="processing-title">启动救援中</div>

      <!-- 副标题 -->
      <div class="processing-subtitle">请关注来电接听</div>

      <!-- 步骤列表 -->
      <div class="processing-steps">
        <transition name="step-fade">
          <div v-if="showStep1" class="step-item">
            <div class="step-check" :class="{ 'step-check-complete': step1Complete }">
              <div v-if="!step1Complete" class="step-loading"></div>
              <i v-else class="el-icon-check"></i>
            </div>
            <div class="step-text">位置已锁定</div>
          </div>
        </transition>
        <transition name="step-fade">
          <div v-if="showStep2" class="step-item">
            <div class="step-check" :class="{ 'step-check-complete': step2Complete }">
              <div v-if="!step2Complete" class="step-loading"></div>
              <i v-else class="el-icon-check"></i>
            </div>
            <div class="step-text">权益已查询</div>
          </div>
        </transition>
        <transition name="step-fade">
          <div v-if="showStep3" class="step-item">
            <div class="step-check" :class="{ 'step-check-complete': step3Complete }">
              <div v-if="!step3Complete" class="step-loading"></div>
              <i v-else class="el-icon-check"></i>
            </div>
            <div class="step-text">服务资源调度中</div>
          </div>
        </transition>
      </div>
      </div>

      <!-- 倒计时按钮 -->
      <div class="processing-footer">
        <div class="countdown-btn">
          {{ countdown }}秒后返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'RescueProcessing',
  data() {
    return {
      countdown: 5,
      countdownTimer: null,
      showStep1: false,
      showStep2: false,
      showStep3: false,
      step1Complete: false,
      step2Complete: false,
      step3Complete: false
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  mounted() {
    document.title = '启动救援中';
    // 设置页面背景色
    document.body.style.backgroundColor = '#F2F3F5';
    // 开始步骤动画
    this.startStepAnimation();
    // 开始倒计时
    this.startCountdown();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    /**
     * 开始步骤动画
     */
    startStepAnimation() {
      // 第一个步骤：500ms后显示，1.5秒后完成
      setTimeout(() => {
        this.showStep1 = true;
        setTimeout(() => {
          this.step1Complete = true;
          
          // 第二个步骤：第一个完成后500ms显示，1.5秒后完成
          setTimeout(() => {
            this.showStep2 = true;
            setTimeout(() => {
              this.step2Complete = true;
              
              // 第三个步骤：第二个完成后500ms显示，1.5秒后完成
              setTimeout(() => {
                this.showStep3 = true;
                setTimeout(() => {
                  this.step3Complete = true;
                }, 500);
              }, 200);
            }, 500);
          }, 200);
        }, 500);
      }, 200);
    },
    /**
     * 开始倒计时
     */
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          // 倒计时结束，跳转到服务页
          this.$router.replace({ name: 'newIndex' });
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  font-family: "微软雅黑";
  box-sizing: border-box;
}

.rescue-processing-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 100px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 */
  .processing-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
    padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
  }

  /* 内容区域 */
  .processing-content {
    width: 100%;
    padding: 20px 16px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
    box-sizing: border-box;
  }
}

/* 内容卡片 */
.processing-content-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 20px;
  margin: 0 auto;
  max-width: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}

/* 图标区域 */
.processing-icon {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.processing-icon-img {
  width: auto;
  height: auto;
  max-width: 120px;
  max-height: 120px;
  display: block;
}

/* 主标题 */
.processing-title {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 12px;
  text-align: center;
  letter-spacing: 0.5px;
}

/* 副标题 */
.processing-subtitle {
  font-size: 14px;
  color: #666666;
  margin-bottom: 40px;
  text-align: center;
  font-weight: 400;
}

/* 步骤列表 */
.processing-steps {
  width: 100%;
  max-width: 100%;
}

.step-item {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.step-check {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #E8E8E8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
  position: relative;
  transition: all 0.3s ease;
  
  &.step-check-complete {
    background: #00C275;
    box-shadow: 0 2px 4px rgba(0, 194, 117, 0.3);
    animation: checkPop 0.3s ease;
  }
  
  i {
    color: #FFFFFF;
    font-size: 12px;
    font-weight: bold;
  }
}

/* 加载动画 */
.step-loading {
  width: 12px;
  height: 12px;
  border: 2px solid #00C275;
  border-top-color: transparent;
  border-radius: 50%;
  animation: loadingSpin 0.8s linear infinite;
}

@keyframes loadingSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes checkPop {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 步骤出现动画 */
.step-fade-enter-active {
  transition: all 0.5s ease;
}

.step-fade-enter {
  opacity: 0;
  transform: translateY(-10px);
}

.step-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.step-text {
  font-size: 15px;
  color: #333333;
  line-height: 22px;
  font-weight: 400;
}

/* 底部倒计时按钮 */
.processing-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.countdown-btn {
  width: 100%;
  max-width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #ffffff;
  font-size: 15px;
  border-radius: 22px;
  cursor: default;
  user-select: none;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
}
</style>




// WEBPACK FOOTER //
// src/views/rescueProcessing/index.vue